import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { LeadSourceTag } from '@shared/models/lead-source-tag';
import { LeadSource } from '@shared/types/lead-source';
import { loadLeadSourceTags } from '../actions/load-lead-source-tags.actions';
import { createLeadSourceTag } from '../actions/create-lead-source-tag.actions';
import { selectAllLeadSourceTags, selectLeadSourceTagsForLeadSource } from '../reducers/lead-source-tags.reducer';
import { LoadingState } from '@shared/types/loading-state';
import { selectLeadSourceTagLoadingState } from '../reducers/lead-source-tags.reducer';

@Injectable({
  providedIn: 'root',
})
export class LeadSourceTagsService {
  constructor(private store: Store) {}

  loadLeadSourceTags() {
    this.store.dispatch(loadLeadSourceTags());
  }

  createLeadSourceTag(tag: Partial<LeadSourceTag>) {
    this.store.dispatch(createLeadSourceTag({ leadSourceTag: tag }));
  }

  getLeadSourceTags(): Observable<LeadSourceTag[]> {
    return this.store.select(selectAllLeadSourceTags);
  }

  getLeadSourceTagsByLeadSource(leadSource: LeadSource, searchTerm = ''): Observable<LeadSourceTag[]> {
    return this.store.select(selectLeadSourceTagsForLeadSource(leadSource, searchTerm));
  }

  getLeadSourceTagsLoadingState(): Observable<LoadingState> {
    return this.store.select(selectLeadSourceTagLoadingState);
  }
}
